<template> 
  <div>
    <vs-card class="p-4 mb-6">
        <div class="flex flex-wrap items-center justify-between mb-4">
            <div class="flex items-center">
                <h5 style="margin-left: 10px">Manifest List</h5>
            </div>

            <div class="flex items-center">
                <vs-button @click="refreshData" class="btn mb-4 md:mb-0 mr-1" icon="refresh">Refresh</vs-button>
                <vs-button class="btn mb-4 md:mb-0 mr-1" icon="directions_bus" @click="showVehiclePopup">Add Vehicle</vs-button>
                <vs-button class="btn mb-4 md:mb-0 mr-1" icon="event_busy" @click="CanceledOrderPopup">Canceled Orders</vs-button>
                <!-- <vs-button :to="{ name: 'transportorder-view', params: {id: selectedId} }" class="mb-4 md:mb-0 mr-1" icon="remove_red_eye" :disabled="selectedId ? false : true">View</vs-button> -->
                <!-- <vs-button class="mb-4 md:mb-0 mr-1" color="warning">Edit</vs-button> -->
                <!-- <vs-button class="mb-4 md:mb-0 mr-1" @click="removeItem" icon="delete" :disabled="selectedId ? false : true">Delete</vs-button> -->
                <!-- <vs-button class="mb-4 md:mb-0 mr-1" @click="filterActive" icon="filter_list">Filter</vs-button> -->

            </div>
        </div>

    <div class="vx-row" >
        <div class="vx-col w-full" style="height:500px; overflow-y: auto;">
            
             <vs-collapse type="margin" accordion>
                <vs-collapse-item :key="indextr" v-for="(tr, indextr) in manifest"  icon-pack="feather" icon-arrow="icon-chevrons-down">
                  <div slot="header">
                    <!-- <small> -->
                         <strong>{{ `Manifest `+ tr.id }} - Routed Orders ({{ tr.order_list.length }})</strong> {{'/ '+ tr.schedule_date +' - Trip : '+tr.trip +' / "'+tr.vehicle.vehicle_code+'" - Driver : '+tr.vehicle.driver+' - '+tr.vehicle_type.vehicle_type + ' - '+tr.transporter.transporter_code}}
                    <!-- </small> -->
                  </div>

                  <vs-table id="routedOrder" :data="tr.order_list" v-show="tr.order_list.length > 0" stripe hoverFlat>

                    <template slot="thead">
                      <vs-th>ID</vs-th>
                      <vs-th>Reference</vs-th>
                      <vs-th>Req. Del. Date</vs-th>
                      <vs-th>Origin Address</vs-th>
                      <vs-th>Origin Area</vs-th>
                      <vs-th>Destination Address</vs-th>
                      <vs-th>Destination Area</vs-th>
                      <vs-th>Quantity</vs-th>
                      <vs-th></vs-th>
                    </template>

                    <template slot-scope="{data}">
                       <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
      
                            <vs-td :data="tr.tro_id">
                             {{ tr.tro_id }}
                            </vs-td>
                            <vs-td :data="tr.transport_reference">
                              {{ tr.transport_reference }}
                            </vs-td>
                            <vs-td :data="tr.req_del_date">
                              {{ tr.req_del_date }}
                            </vs-td>
                            <vs-td :data="tr.origin_address1">
                              {{ tr.origin_address1 }}
                            </vs-td>
                            <vs-td :data="tr.origin_area.id">
                              {{ tr.origin_area.subdistrict }}
                            </vs-td>
                            <vs-td :data="tr.origin_address1">
                              {{ tr.destination_address1 }}
                            </vs-td>
                            <vs-td :data="tr.destination_area.id">
                              {{ tr.destination_area.subdistrict }}
                            </vs-td>
                            <vs-td :data="tr.sum_qty">
                              {{ tr.sum_qty }}
                            </vs-td>
                            <vs-td>
                                <vs-dropdown vs-trigger-click class="mr-1">
                                    <vs-button class="btn-drop" type="filled" icon="expand_more" size="small">Action</vs-button>
                                    <vs-dropdown-menu id="ActionDDL">
                                        <vs-dropdown-item @click="moveToUnroutedOrder(tr.id)">
                                            Move to Unrouted Order
                                        </vs-dropdown-item>
                                        <vs-dropdown-item  @click="moveToCanceledOrder(tr.tro_id)">
                                            Move to Canceled Order
                                        </vs-dropdown-item>
                                        <vs-dropdown-item @click="viewOrder2(tr.tro_id)">
                                            View Order
                                        </vs-dropdown-item>
                                    </vs-dropdown-menu>
                                </vs-dropdown>
                            </vs-td>
                          </vs-tr>
                    </template>

                  </vs-table>

                    <div class="flex flex-wrap items-center mt-4 mr-2">
                         <div class="flex">
                            <vs-button class="mr-1" icon="remove_red_eye" @click="viewManifest(tr.id)" size="small">View</vs-button>
                            <vs-button class="mr-1" @click="removeManifest(tr)" color="warning" icon="delete" size="small">Delete</vs-button>
                            <!-- <vs-button color="success" icon="cloud_upload" size="small">Book API</vs-button> -->
                        </div>
                    </div>
                </vs-collapse-item>
              </vs-collapse>

      <!--         <vs-list-item class="flex items-center p-1" v-for="(item, index) in list" :key="index" :title="item">
              </vs-list-item> -->

        </div>
    </div>

</vs-card>


<!-- filter-order -->
 <vs-prompt @accept="filterData" title="Filter" :active.sync="showFilter">
    <div class="con-exemple-prompt">
        <vs-input placeholder="Reference" v-model="filter.transport_reference" class="mt-4 mb-2 w-full" />
        <vs-input placeholder="Origin Name" v-model="filter.origin" class="mt-4 mb-2 w-full" />
        <v-select placeholder="Origin Area"  v-model="filter.origin_area_id" :options="areaOptions" label="village"  @search="searchArea" :clearable="true" ></v-select>
        <vs-input placeholder="Destination Name" v-model="filter.destination" class="mt-4 mb-2 w-full" />
        <v-select placeholder="Destination Name" v-model="filter.destination_area_id" :options="areaOptions" label="village" @search="searchArea" :clearable="true" ></v-select>
    </div>
</vs-prompt>


<vs-card  class="p-4 mb-6" >
    <div class="flex flex-wrap items-center justify-between mb-10">
        <div class="flex items-center">
            <h5 style="margin-left: 10px">Unrouted Orders</h5>
        </div>
          <div class="flex items-center">
               <vs-button class="mb-4 md:mb-0 mr-1" @click="viewOrder" icon="remove_red_eye" :disabled="selectedOrder.length != 1">View</vs-button>
               <vs-button class="mb-4 md:mb-0 mr-1" @click="filterActive" icon="filter_list">Filter</vs-button>
               <vs-button class="btn mb-4 md:mb-0 mr-1" icon="present_to_all" @click="showManifestPopup" :disabled="selectedOrder.length <= 0">Route to Manifest</vs-button>
               <vs-button class="btn mb-4 md:mb-0 mr-1" icon="cancel_presentation" color="danger" @click="moveIntoCancelOrder" :disabled="selectedOrder.length <= 0">Move to Canceled</vs-button>
            </div>
    </div>


    <div class="vx-row">
        <div class="vx-col w-full" style="height:500px; overflow-y: auto;">
            
     <vs-table id="routedOrder" multiple :data="transports" v-model="selectedOrder" stripe hoverFlat>

        <template slot="thead">
          <vs-th></vs-th>
          <vs-th>ID</vs-th>
          <vs-th>Reference</vs-th>
          <vs-th>Req. Del. Date</vs-th>
          <vs-th>Origin Address</vs-th>
          <vs-th>Origin Area</vs-th>
          <vs-th>Destination Address</vs-th>
          <vs-th>Destination Area</vs-th>
          <vs-th>Quantity</vs-th>
          <!-- <vs-th>Action</vs-th> -->
          <!-- <vs-th>Remark</vs-th> -->

        </template>

        <template slot-scope="{data}">
            <!-- <draggable :list="list" class="cursor-move"> -->
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <!--     <vs-td :data="tr.base_nw">
                    <vs-button line-origin="left" color="success" type="line">
                        View
                    </vs-button>
                </vs-td> -->
                <vs-td :data="tr.id">
                  <vs-chip  :color="chipColor(tr.confirm_response)" id="stat-chip" v-show="tr.tracking_reference != null"></vs-chip>
                </vs-td>
                <vs-td :data="tr.id">
                {{ tr.id }}
                </vs-td>
                <vs-td :data="tr.transport_reference">
                {{ tr.transport_reference }}
                </vs-td>
                <vs-td :data="tr.req_del_date">
                {{ tr.req_del_date }}
                </vs-td>
                <vs-td :data="tr.origin_address1">
                {{ tr.origin_address1 }}
                </vs-td>
                <vs-td :data="tr.origin_area.id">
                {{ tr.origin_area.subdistrict }}
                </vs-td>
                <vs-td :data="tr.destination_address1">
                {{ tr.destination_address1 }}
                </vs-td>
                <vs-td :data="tr.destination_area">
                {{ tr.destination_area.subdistrict }}
                </vs-td>
                <vs-td :data="tr.sum_qty">
                {{ tr.sum_qty }}
                </vs-td>
            </vs-tr>
                <!-- </draggable> -->
        </template>
  </vs-table>
    
    </div>
</div>



</vs-card>

<!-- add route tro into manifest -->
<vs-popup title="Select manifest to route order" :active.sync="showAddManifest">
        <div class="row pb-5">
            <vs-table search v-model="selectedManifest" :data="dataManifest" hoverFlat>
              <template slot="thead">
                <vs-th sort-key="id">Manifest ID</vs-th>
                <vs-th sort-key="schedule_date">Schedule Date</vs-th>
                <vs-th sort-key="trip">Trip</vs-th>
                <vs-th sort-key="vehicle.vehicle_code">Vehicle ID</vs-th>
                <vs-th sort-key="vehicle.driver">Driver</vs-th>
                <vs-th sort-key="vehicle_type.vehicle_type">Vehcile Type</vs-th>
                <vs-th sort-key="transporter.transporter_code">Transporter Code</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].id">
                    {{ data[indextr].id }}
                  </vs-td>

                  <vs-td :data="data[indextr].schedule_date">
                    {{ data[indextr].schedule_date }}
                  </vs-td>

                  <vs-td :data="data[indextr].trip">
                    {{ data[indextr].trip }}
                  </vs-td>

                  <vs-td :data="data[indextr].vehicle_code">
                    {{ data[indextr].vehicle_code }}
                  </vs-td>

                 <vs-td :data="data[indextr].driver">
                    {{ data[indextr].driver }}
                  </vs-td>

                  <vs-td :data="data[indextr].vehicle_type">
                    {{ data[indextr].vehicle_type }}
                  </vs-td>

                  <vs-td :data="data[indextr].transporter_code" >
                    {{ data[indextr].transporter_code }}
                  </vs-td>
        
                </vs-tr>
              </template>
            </vs-table>
          
        </div>

    <div class="flex flex-wrap items-center justify-end mt-5">
        <div class="flex items-center">
            <vs-button class="mb-4 md:mb-0" icon="add" @click="addOrderIntoManifest" color="primary" :disabled=" selectedManifest == '' || selectedManifest == null" >Add</vs-button>
        </div>
    </div>
</vs-popup>

<!-- add manifet from vehicle -->
<vs-popup title="Select Vehicle ID" :active.sync="showAddVehicle">
        <div class="row pb-5">
            <vs-table stripe max-items="30" pagination search hoverFlat v-model="selectedVehicle" :data="dataVehicles">
                <template slot="header">
                    
                    <!--<div class="vx-row mb-6">
                      <div class="vx-col md:w-1/3 w-full">
                        <span>Keywords</span>
                      </div>
                      <div class="vx-col md:w-2/3 w-full">
                        <vs-input class="w-full" v-model="keywords_search" />
                      </div>

                    </div>-->

                    <div class="vx-row mb-6">
                      <div class="vx-col md:w-1/3 w-full">
                        <span>Assigned Trip</span>
                      </div>
                      <div class="vx-col md:w-2/3 w-full">
                        <vs-input class="w-full" v-model="trip_count" />
                      </div>
                    </div>

                </template>
              <template slot="thead">
                <vs-th sort-key="id">Vehicle ID</vs-th>
                <vs-th sort-key="vehicle_code">Vehicle Code</vs-th>
                <vs-th sort-key="vehicle_type.vehicle_type">Vehicle Type</vs-th>
                <vs-th sort-key="transport.transporter_code">Transporter ID</vs-th>
                <vs-th sort-key="driver">Driver</vs-th>
                <vs-th sort-key="phone">Phone</vs-th>
                <vs-th sort-key="contract_type.contract_type">Contract Type</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].id">
                        {{ data[indextr].id }}
                  </vs-td>

                  <vs-td :data="data[indextr].vehicle_code">
                        {{ data[indextr].vehicle_code }}
                  </vs-td>

                  <vs-td :data="data[indextr].vehicle_type_id">
                    {{ data[indextr].vehicle_type.vehicle_type }}
                  </vs-td>

                  <vs-td :data="data[indextr].transporter_id">
                    {{ data[indextr].transporter_code }}
                  </vs-td>

                  <vs-td :data="data[indextr].id">
                    {{ data[indextr].driver }}
                  </vs-td>

                  <vs-td :data="data[indextr].id">
                    {{ data[indextr].phone }}
                  </vs-td>

                  <vs-td :data="data[indextr].contract_type_id" >
                    {{ data[indextr].contract_type }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
        </div>

    <div class="flex flex-wrap items-center justify-end mt-5">
        <div class="flex items-center">
            <!-- <vs-button class="mb-4 md:mb-0 mr-5" icon="close" @click="showAddVehicle = false" color="warning" :disabled="false" >Close</vs-button> -->
            <vs-button class="mb-4 md:mb-0" icon="add" @click="addManifest" color="primary" :disabled="selectedVehicle == null || selectedVehicle == '' " >Add</vs-button>
        </div>
    </div>
</vs-popup>
<!-- end route tro into manifest -->

<!-- start-popup-canceled_order -->
<vs-popup title="Canceled Orders" :active.sync="showCanceledOrder" id="myPopup2">
        <div class="row pb-5">
            <vs-table v-model="selectedCanceledOrder" :data="dataCanceledOrder" multiple hoverFlat>
                <!-- <template slot="header">
                    
                    <div class="vx-row mb-6">
                      <div class="vx-col md:w-1/3 w-full">
                        <span>Keywords</span>
                      </div>
                      <div class="vx-col md:w-2/3 w-full">
                        <vs-input class="w-full" v-model="keywords_search" />
                      </div>

                    </div>

                    <div class="vx-row mb-6">
                      <div class="vx-col md:w-1/3 w-full">
                        <span>Assigned Trip</span>
                      </div>
                      <div class="vx-col md:w-2/3 w-full">
                        <vs-input class="w-full" v-model="trip_count" />
                      </div>
                    </div>

                </template> -->

                        
                <template slot="thead">
                <vs-th>ID</vs-th>
                <vs-th>Reference</vs-th>
                <vs-th>Req. Del. Date</vs-th>
                <vs-th>Origin Name</vs-th>
                <vs-th>Origin Address</vs-th>
                <vs-th>Origin Area</vs-th>
                <vs-th>Destination Name</vs-th>
                <vs-th>Destination Address</vs-th>
                <vs-th>Destination Area</vs-th>
                <vs-th>Quantity</vs-th>
                <!-- <vs-th>Action</vs-th> -->
                <!-- <vs-th>Remark</vs-th> -->

                </template>

                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :data="tr.id">
                        {{ tr.id }}
                        </vs-td>
                        <vs-td :data="tr.transport_reference">
                        {{ tr.transport_reference }}
                        </vs-td>
                        <vs-td :data="tr.req_del_date">
                        {{ tr.req_del_date }}
                        </vs-td>
                        <vs-td :data="tr.origin_area.id">
                        {{ tr.origin_area.village }}
                        </vs-td>
                        <vs-td :data="tr.origin_address1">
                        {{ tr.origin_address1 }}
                        </vs-td>
                        <vs-td :data="tr.origin_area.id">
                        {{ tr.origin_area.village }}
                        </vs-td>
                        <vs-td :data="tr.destination_area">
                        {{ tr.destination_area.village }}
                        </vs-td>
                        <vs-td :data="tr.destination_address1">
                        {{ tr.destination_address1 }}
                        </vs-td>
                        <vs-td :data="tr.destination_area">
                        {{ tr.destination_area.village }}
                        </vs-td>
                        <vs-td :data="tr.sum_qty">
                        {{ tr.sum_qty }}
                        </vs-td>
                    </vs-tr>
                </template>

            </vs-table>
        </div>

    <div class="flex flex-wrap justify-end mt-5">
        <div class="flex items-center">
            <vs-button class="mb-4 md:mb-0"  @click="moveIntoUnroutedOrder" color="primary" :disabled="selectedCanceledOrder.length <= 0" >Move to Unrouted</vs-button>
        </div>
    </div>
</vs-popup>
<!-- start-popup-canceled_order -->



<vs-popup :title="'Manifest '+single_manifest.id" :active.sync="showPopupManifest" id="myPopup">
    
    <div class="row pt-2 pb-4 px-4">
      <div class="flex flex-wrap items-center justify-between mb-6">
            <div class="flex items-center">
                <vs-button class="btn mb-4 md:mb-0 mr-1" icon="edit" :disabled="editMode || scanMode" @click="editManifest">Edit</vs-button>
                <vs-dropdown vs-trigger-click class="mr-1" :disabled="editMode || scanMode">
                    <vs-button class="btn-drop" type="filled" icon="expand_more" :disabled="editMode || scanMode">Proccess</vs-button>
                    <vs-dropdown-menu>
                        <!-- <vs-dropdown-group vs-collapse vs-label="Batch Pick" vs-icon="add">
                            <vs-dropdown-item>
                                Create Picking
                            </vs-dropdown-item>
                            <vs-dropdown-item>
                                Confirm Picking
                            </vs-dropdown-item>
                            <vs-dropdown-item divider>
                                Print Batch Pick
                            </vs-dropdown-item>
                        </vs-dropdown-group>
                        <vs-dropdown-item divider>
                            Good Issue All DO
                        </vs-dropdown-item> -->

                        <vs-dropdown-item divider @click="confirmManifest">
                            Confirm Manifest
                        </vs-dropdown-item>
                        <vs-dropdown-item :disabled="true">
                            Unconfirm Manifest
                        </vs-dropdown-item>
                    </vs-dropdown-menu>
	            </vs-dropdown>
                <vs-button class="mb-4 md:mb-0 mr-1" icon="remove_red_eye" @click="exportTransportNote" >Print</vs-button>
                
            </div>
      </div>

    <vs-tabs alignment="center"  v-model="activeTab" :value="activeTab">
        <vs-tab label="Detail">
        
       <div class="vx-row pt-5">
          <div class="vx-col lg:w-1/3 w-full">
              <div class="vx-row mb-3">
                  <div class="vx-col w-1/3">
                      Manifest
                  </div>
                  <div class="vx-col w-2/3">
                      <vs-input v-model="single_manifest.id" class="w-full" disabled/>
                  </div>
              </div>
              <div class="vx-row mb-3 mt-1">
                  <div class="vx-col w-1/3">
                      Schedule Date
                  </div>
                  <div class="vx-col w-2/3">
                      <flat-pickr v-model="single_manifest.schedule_date" class="w-full" :disabled="!editMode"/>
                  </div>
              </div>
              <div class="vx-row mb-3">
                  <div class="vx-col w-1/3">
                      Trip
                  </div>
                  <div class="vx-col w-2/3">
                      <vs-input v-model="single_manifest.trip" class="w-full" :disabled="!editMode"/>
                  </div>
              </div>
          </div>
          <div class="vx-col lg:w-1/3 w-full">
              <div class="vx-row mb-3">
                  <div class="vx-col w-1/3">
                     Reference
                  </div>
                  <div class="vx-col w-2/3">
                      <vs-input v-model="single_manifest.reference" class="w-full" :disabled="true"/>
                  </div>
              </div>
              <div class="vx-row mb-3">
                  <div class="vx-col w-1/3">
                      Origin
                  </div>
                  <div class="vx-col w-2/3">
                      <v-select v-model="single_manifest.origin_id" :options="areaOptions" label="village" @search="searchArea" :clearable="true" :disabled="!editMode"></v-select>
                  </div>
              </div>
              <div class="vx-row mb-3">
                  <div class="vx-col w-1/3">
                      Destination
                  </div>
                  <div class="vx-col w-2/3">
                      <v-select v-model="single_manifest.destination_id" :options="areaOptions" label="village" @search="searchArea" :clearable="true" :disabled="!editMode"></v-select>
                  </div>
              </div>
          </div>
          <div class="vx-col lg:w-1/3 w-full">

              <div class="vx-row mb-3">
                  <div class="vx-col w-1/3">
                      Status
                  </div>
                  <div class="vx-col w-2/3">
                      <vs-input v-model="single_manifest.status.name" class="w-full" :disabled="true"/>
                  </div>
              </div>
              
              <div class="vx-row mb-3">
                  <div class="vx-col w-1/3">
                      Client ID
                  </div>
                  <div class="vx-col w-2/3">
                      <v-select v-model="single_manifest.client_id" :options="clientOption" label="client_code" :clearable="false" :disabled="!editMode"></v-select>
                  </div>
              </div>
              <div class="vx-row mb-3">
                  <div class="vx-col w-1/3">
                      Warehouse ID
                  </div>
                  <div class="vx-col w-2/3">
                      <v-select v-model="single_manifest.warehouse_id" :options="warehouseOptions" label="name" :clearable="true" :disabled="!editMode"></v-select>
                  </div>
              </div>
          </div>
      </div>

        <vs-tabs style="height:100%;" class="mt-8">
          <vs-tab label="Vehicle Summary">
            <div class="vx-row mt-4">
                <div class="vx-col lg:w-1/3 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Vehicle Master
                        </div>
                        <div class="vx-col w-2/3">
                            <v-select v-model="single_manifest.vehicle_id" :options="vehicleOption" label="vehicle_code" @input="setVehicle()" :clearable="false" :disabled="!editMode"></v-select>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Vehicle
                        </div>
                        <div class="vx-col w-2/3">
                            <v-select v-model="single_manifest.alter_vehicle_id" :options="vehicleOption" label="vehicle_code"  @input="setAlterVehicle()"  :clearable="false" :disabled="!editMode"></v-select>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                           Driver
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input  v-model="single_manifest.driver"  class="w-full" :disabled="!editMode"/>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                           Phone
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input  v-model="single_manifest.phone" class="w-full" :disabled="!editMode"/>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Vehicle Type
                        </div>
                        <div class="vx-col w-2/3">
                            <v-select v-model="single_manifest.vehicle_type_id" :options="vehicleTypeOption" label="vehicle_type" :clearable="false" :disabled="!editMode"></v-select>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Transporter 
                        </div>
                        <div class="vx-col w-2/3">
                            <v-select v-model="single_manifest.transporter_id" :options="transporterOption" label="transporter_code" :clearable="false" :disabled="!editMode"></v-select>
                        </div>
                    </div>
                </div>
                <div class="vx-col lg:w-1/3 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                           Cap. Volume
                        </div>
                        <div class="vx-col w-2/3">
                            <vx-input-group>
                            <template slot="append">
                                <div class="append-text bg-primary">
                                <span>M3</span>
                                </div>
                            </template>
                            <vs-input  v-model="single_manifest.vehicle_id.cap_volume" class="w-full" :disabled="!editMode"/>
                            </vx-input-group>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                           Cap. Weight
                        </div>
                        <div class="vx-col w-2/3">
                            <vx-input-group>
                            <template slot="append">
                                <div class="append-text bg-primary">
                                <span>KG</span>
                                </div>
                            </template>
                            <vs-input  v-model="single_manifest.vehicle_id.cap_weight" class="w-full" :disabled="!editMode"/>
                            </vx-input-group>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                           Load Volume
                        </div>
                        <div class="vx-col w-2/3">
                            <vx-input-group>
                            <template slot="append">
                                <div class="append-text bg-primary">
                                <span>M3</span>
                                </div>
                            </template>
                            <vs-input  v-model="single_manifest.load_volume" class="w-full" :disabled="!editMode"/>
                            </vx-input-group>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                           Load Weight
                        </div>
                        <div class="vx-col w-2/3">
                            <vx-input-group>
                            <template slot="append">
                                <div class="append-text bg-primary">
                                <span>KG</span>
                                </div>
                            </template>
                            <vs-input  v-model="single_manifest.load_weight" class="w-full" :disabled="!editMode"/>
                            </vx-input-group>
                        </div>
                    </div>
                     <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                           Load Quantity
                        </div>
                        <div class="vx-col w-2/3">
                             <vx-input-group>
                            <template slot="append">
                                <div class="append-text bg-primary">
                                <span>Unit</span>
                                </div>
                            </template>
                            <vs-input  v-model="single_manifest.load_quantity" class="w-full" :disabled="!editMode"/>
                            </vx-input-group>
                        </div>
                    </div>
                </div>
                <div class="vx-col lg:w-1/3 w-full">

                <div class="vx-row mb-3">
                    <div class="vx-col w-1/3">
                        Transporter Mode
                    </div>
                    <div class="vx-col w-2/3">
                        <v-select v-model="single_manifest.transporter_mode_id" :options="transporterModeOption" label="mode" :clearable="false" :disabled="!editMode"></v-select>
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col w-1/3">
                        Container No.
                    </div>
                    <div class="vx-col w-2/3">
                        <vs-input  v-model="single_manifest.container_number"  class="w-full" :disabled="!editMode"/>
                    </div>
                </div>
                   
                <div class="vx-row mb-3">
                    <div class="vx-col w-1/3">
                        Seal No.
                    </div>
                    <div class="vx-col w-2/3">
                        <vs-input  v-model="single_manifest.seal_number"  class="w-full" :disabled="!editMode"/>
                    </div>
                </div>
                   
                <div class="vx-row mb-3">
                    <div class="vx-col w-1/3">
                        Vessel No.
                    </div>
                    <div class="vx-col w-2/3">
                        <vs-input  v-model="single_manifest.vessel_number"  class="w-full" :disabled="!editMode"/>
                    </div>
                </div>
                   
                <div class="vx-row mb-3">
                    <div class="vx-col w-1/3">
                        Voyage No.
                    </div>
                    <div class="vx-col w-2/3">
                        <vs-input  v-model="single_manifest.voyage_number"  class="w-full" :disabled="!editMode"/>
                    </div>
                </div>


                </div>
            </div>
          </vs-tab>
<!-- 
          <vs-tab label="Picking Summary">
          </vs-tab> -->
          <vs-tab label="Tracking Summary">
          </vs-tab>
          <vs-tab label="Notes">
          </vs-tab>
           <vs-tab label="Attachment">
                        <input 
              type="file" 
              id="file_name"
              v-on:change="handleFileUpload($event)" :hidden="!editMode"
            />
                        <vs-table :data="attachments" :hidden="editMode">
                            <template slot="thead">
                                <vs-th>No.</vs-th>
                                <vs-th>File Name</vs-th>
                                <vs-th>Action</vs-th>
                            </template>
                            <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                <vs-td :data="indextr">
                                    {{ indextr + 1 }}
                                </vs-td>
                                <vs-td :data="data[indextr].file_name">
                                    {{ data[indextr].file_name }}
                                </vs-td>
                                <vs-td :data="indextr">
                                    <vs-button color="success" class="btn mb-4 md:mb-0 mr-1" @click="removeDetail(index)" :disabled="editMode ? false : true">Download</vs-button>
                                    <vs-button color="danger" class="btn mb-4 md:mb-0 mr-1" @click="removeDetail(index)" :disabled="editMode ? false : true">Remove</vs-button>
                                </vs-td>
                            </vs-tr>
                            </template>
                        </vs-table>
                    </vs-tab>
        </vs-tabs>

        <div class="flex flex-wrap justify-end">
                <div class="flex">
                    <vs-button color="warning" class="btn mr-1" @click="discardManifest" v-show="editMode">Cancel</vs-button>
                    <vs-button class="btn mr-1" :disabled="!editMode" @click="updateManifest">Save</vs-button>
                </div>
        </div>

        </vs-tab>

        
        <vs-tab label="Order List">
            <vs-table id="routedOrder" style="min-height:400px" :data="single_manifest.order_list" stripe hoverFlat>
                <template slot="thead">
                    <vs-th>ID</vs-th>
                    <vs-th>Reference</vs-th>
                    <vs-th>Req. Del. Date</vs-th>
                    <vs-th>Origin Name</vs-th>
                    <!-- <vs-th>Origin Address</vs-th> -->
                    <!-- <vs-th>Origin Area</vs-th> -->
                    <vs-th>Destination Name</vs-th>
                    <!-- <vs-th>Destination Address</vs-th> -->
                    <!-- <vs-th>Destination Area</vs-th> -->
                    <vs-th>Quantity</vs-th>
                    <vs-th>Volume (M3)</vs-th>
                    <vs-th>Weight (M3)</vs-th>
                    <vs-th></vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :data="tr.tro_id">
                            {{ tr.tro_id }}
                        </vs-td>
                        <vs-td :data="tr.transport_reference">
                            {{ tr.transport_reference }}
                        </vs-td>
                        <vs-td :data="tr.req_del_date">
                            {{ tr.req_del_date }}
                        </vs-td>
                        <vs-td :data="tr.origin.id">
                            {{ tr.origin.name }}
                        </vs-td>
                        <!--    <vs-td :data="tr.origin.id">
                            {{ tr.origin.address_1 }}
                        </vs-td> -->
                        <!-- <vs-td :data="tr.origin_area.id">
                            {{ tr.origin_area.village }}
                        </vs-td> -->
                        <vs-td :data="tr.destination.id">
                            {{ tr.destination.name }}
                        </vs-td>
                    <!--      <vs-td :data="tr.destination.id">
                            {{ tr.destination.address_1 }}
                        </vs-td> -->
                        <!-- <vs-td :data="tr.destination_area.id">
                            {{ tr.destination_area.village }}
                        </vs-td> -->
                        <vs-td :data="tr.sum_qty">
                            {{ tr.sum_qty }}
                        </vs-td>
                        <vs-td :data="tr.base_volume">
                            {{ tr.base_volume }}
                        </vs-td>
                        <vs-td :data="tr.base_gw">
                            {{ tr.base_gw }}
                        </vs-td>
                        <vs-td>
                        <vs-dropdown vs-trigger-click class="mr-1" :disabled="!scanMode">
                                <vs-button class="btn-drop" type="filled" icon="expand_more" size="small" :disabled="!scanMode">Action</vs-button>
                                <vs-dropdown-menu id="ActionDDL">
                                    <vs-dropdown-item @click="moveToUnroutedOrderFromTab(tr.id)">
                                        Move to Unrouted Order
                                    </vs-dropdown-item>
                                    <vs-dropdown-item  @click="moveToCanceledOrderFromTab(tr.tro_id)">
                                        Move to Canceled Order
                                    </vs-dropdown-item>
                                </vs-dropdown-menu>
                            </vs-dropdown>
                        </vs-td>
                        </vs-tr>
                </template>
            </vs-table>
        </vs-tab>

    </vs-tabs>

        <vs-popup title="Close without Save ?" :active.sync="closePopupManifest">
            <p></p>
        </vs-popup>

    </div>
</vs-popup>


<vs-popup title="" :active.sync="showViewOrder" id="myPopup2">
   <tro-view :tro_param_id="tro_view_id"></tro-view>
</vs-popup>

<vs-popup title="Update AWB" :active.sync="update.show">
    <div class="con-exemple-prompt">
        <vs-input placeholder="New AWB" v-model="update.awb" class="mt-4 mb-2 w-full" />
    </div>
    <div class="flex flex-wrap items-center justify-end mt-5">
        <div class="flex items-center">
            <vs-button class="mb-4 md:mb-0 mr-2" @click="getNewAWB">Get New AWB</vs-button>
            <vs-button @click="saveNewAWB">Save New AWB</vs-button>
        </div>
    </div>
</vs-popup>



  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import draggable from 'vuedraggable'

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { error } from 'util'
import TroView from "./TransportOrder"

export default {
    components: {
        vSelect,
        AgGridVue,
        draggable,
        flatPickr,
        TroView
    },
    data() {
        return {
            update: {
                id: null,
                awb: '',
                show: false
            },
            currentPage:1,
            currentx: 8,
            tro_view_id:0,
            editMode:false,
            scanMode:false,
            searchQuery: '',
            gridOptions: {},
            maxPageNumbers: 7,
            totalPages:0,
            gridApi: null,
            // add-manifest
            showAddVehicle:false,
            showAddManifest:false,
            selectedVehicle:null,
            dataVehicles:[],
            dataManifest:[],
            trip_count:1,
            keywords_search:'',
            // end-add-manifest
            showPopupManifest:false,
            closePopupManifest:false,
            showPopupTransport:false,
            
            showCanceledOrder:false,
            selectedCanceledOrder:[],
            dataCanceledOrder:[],

            activeTab:0,

            showViewOrder:false,

            // start_scan_to_load
            awb_id:'',
            last_scan_id:'',
            last_scan_order: {
                transport_reference:'',
                details:[]
            },
            // end_scan_to_load

            // show-edit-manifest
            single_manifest : {
                id:'',
                trip:'',
                schedule_date:'',
                reference:'',
                origin_id:null,
                destination_id:null,
                status:{
                    id:'',
                    name:''},
                client_id:null,
                warehouse_id:null,
                driver:'',
                phone:'',
                vehicle_id:{
                    box_dimension: '',
                    cap_volume: '',
                    cap_weight: '',
                    contract_type_id: null,
                    driver: '',
                    phone: '',
                    transporter_id: null,
                    vehicle_code: '',
                    vehicle_type_id: null,

                },
                load_volume:'',
                load_weight:'',
                load_quantity:'',
                alter_vehicle_id:null,
                transporter_id: null,
                vehicle_type_id:null,
                transporter_mode_id:null,
                container_number:'',
                seal_number:'',
                vessel_number:'',
                voyage_number:'',
                
                order_list:[]
            },
            // end-show-edit-manifest
            
            oldManifest:{},
            masterSync: false,
            transports: [],
            manifest: [],
            columnDefs: null,
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true
            },
            selectedOrder:[],
            selectedManifest:null,
            selectedId: null,


            // start-single-order
            data_order: {
                transport_order: {
                    id:0,
                    transport_reference: '',
                    req_del_date: '',
                    order_type_id: null,
                    origin: {
                        address_1: '',
                        address_2: ''
                    },
                    client: null,
                    outbound_id: '',
                    destination: {
                        address_1: '',
                        address_2: ''
                    },

                    //transport
                    transporter_id:null,
                    service_type_id:null,
                    tracking_reference:'',
                    payment_type_id:null,
                    currency_id:null,
                    order_value:0,
                    internal_notes:'',
                    external_notes:'',
                },
                transport_order_details: [],
            },

            clientTypeOptions: [],
            areaOptions: [],
            maxRetry: 10,
            orderTypeOptions: [],
            clientOptions: [],
            customerOptions: [],

            productOptions: [],
            warehouseOptions: [],
            stockTypeOptions: [],
            documentLock: [],
            
                // transport
            serviceTypeOption:[],
            transporterOption:[],
            currencyOption:[],
            paymentTypeOption:[],

            // end-single-order


            isLoading: false,
            maxRetry: 10,
            showFilter: false,
            filter: {
                transport_reference:'',
                outbound_reference:'',
                origin:'',
                origin_area_id:null,
                destination:'',
                destination_area_id:null,
            },
            
            areaOptions: [],
            warehouseOptions:[],
            vehicleOption:[],
            transporterOption:[],
            clientOption:[],
            vehicleTypeOption:[],
            contractTypeOption:[],
            transporterModeOption:[],
        }
    },
    watch: {
        // '$store.state.windowWidth'(val) {
        //     if(val <= 576) {
        //         this.maxPageNumbers = 4
        //         this.gridOptions.columnApi.setColumnPinned('email', null)
        //     }
        //     else this.gridOptions.columnApi.setColumnPinned('email', 'left')
        // },

        showPopupManifest:function(){
            if(this.editMode){
            //     this.$vs.dialog({
            //     type: 'confirm',
            //     color: 'warning',
            //     title: 'Close tab without save ?',
            //     text: 'Your changes will lose ?',
            //     accept: function() {
            //         this.editMode = false ;
            //         this.showManifestPopup = false;
            //     },
            //     cancel: function() {
            //         }
            // })

            this.editMode = true ;  
            this.showPopupManifest = true;
            this.activeTab = 0;
            // this.closePopupManifest = true ;
            }
            if(this.scanMode){
                this.activeTab = 1;
                this.editMode = false ;  
                this.scanMode = true;
                this.showPopupManifest = true;
            }
        },
        isLoading: function(){
            if(this.isLoading){
                this.$vs.loading()
            }
            else{
                this.$vs.loading.close()
            }
        },
        currentPage:function() {
          this.requestPaginate(this.currentPage)
        },
    computed: {
        // paginationPageSize() {
        //     if(this.gridApi) return this.gridApi.paginationGetPageSize()
        //     else return 50
        // },
        // totalPages() {
        //     // if(this.gridApi) return this.gridApi.paginationGetTotalPages()
        //     // else 
        //     alert(this.dataVehicles.length)
        //     return this.dataVehicles.length % 1
        // },
        // currentPage:function() {
        //   this.requestPaginate(this.currentPage)
        // },
        // currentPage: {
        //     get() {
        //         if(this.dataVehicles){
        //             this.requestPaginate(this.cu)
        //         } 
        //         else {
                    
        //         }
        //     },
        //     set(val) {
        //         this.gridApi.paginationGoToPage(val - 1)
        //     }
        },
    },
    methods: {
        bookApiAllOrder(){
            // console.log(this.single_manifest)
            if(this.single_manifest.order_list.length <= 0){
                this.$vs.notify({
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-x",
                    text: "No Order Found" 
                });
                return false ;
            }
            this.isLoading = true;
            this.$http.post('transport/routeplanning/bookapi-by-manifest', {manifest_id:this.single_manifest.id})
            .then((resp)=>{
                this.isLoading = false;
                this.finishScan()
                this.scanMode = false ;
                // this.manifest = [];
            })
            .catch((error)=>{
                this.isLoading = false;
                for (const [index, err] of error.response.data.entries()) {
                        this.$vs.notify({
                        color: "danger",
                        iconPack: "feather",
                        icon: "icon-x",
                        text: "" + err
                        });
                    }
            })
        },
        requestPaginate(number){
             this.$http.post("master/vehicle?page="+number)
             .then((resp)=>{
                this.dataVehicles = []
                this.dataVehicles = resp.data.data
             })
             .catch((error)=>{
                this.dataVehicles = []
             })
        },
        chipColor(data){
            if(data == null){
                return 'warning'
            }else{
                let status = data.toLowerCase();
                if(status.includes('error')){
                    return 'danger'
                }else if(status.includes('success')){
                    return 'success'
                }else{
                    return 'primary'
                }
            }
        },
        bookApi(tro_id){
            this.isLoading = true;
            this.$http.post('transport/routeplanning/bookapi', {tro_id})
            .then((resp)=>{
                this.manifest = [];
                this.$http.all([this.$http.get('transport/routeplanning/manifest'), this.$http.post('unlock_all')])
                .then(this.$http.spread((manifest) => {
                    this.manifest = manifest.data
                    setTimeout(() => {
                        this.isLoading = false
                    }, 500)
                }))
                .catch(error => {
                    console.log(error)
                })

            })
            .catch(error => this.handleError(error))
        },
        viewOrder(){
            if(this.selectedOrder.length == 1){
                this.showViewOrder = true
                this.tro_view_id = this.selectedOrder[0].id;
            } 
        },
        viewOrder2(tro_id){
            this.showViewOrder = true
            this.tro_view_id = tro_id;
        },
        scanToLoad(){
            this.scanMode = true ;
            this.editMode = false ;
            this.activeTab = 1;
        },
        saveScan(){
            this.scanMode = false;
            this.refreshData();
        },
        keyEnter: function(e) {
            if (e.keyCode === 13) {
                this.submitScan();
            }
        },
        finishScan(){
                this.viewManifest(this.single_manifest.id)
                this.scanMode = true
                this.activeTab = 1
                this.awb_id = '' ;
        },
        submitScan(){
            if(this.awb_id == ''){
                this.$vs.notify({
                    // title: 'Delete Failed',
                    text: 'Please insert AWB Number',
                    color: 'danger'
                })
                return ;
            }
            let data = {
                awb_id:this.awb_id,
                manifest_id:this.single_manifest.id
            }
            this.isLoading = true;
            this.$http.post('transport/routeplanning/scan-to-load', data)
            .then((resp) => {
                this.isLoading = false;
                this.last_scan_order = resp.data.last_scan_order
                this.last_scan_id = this.awb_id;
                this.finishScan()
            })
            .catch((error)=>{
                this.isLoading = false;
                for(const [index, data] of error.response.data.entries() ){
                     this.$vs.notify({
                        text: data,
                        color: 'danger'
                    })
                }
            })
        },
        CanceledOrderPopup(){
            this.isLoading = true;
            this.$http.get('transport/routeplanning_noninternal/canceled')
            .then((resp) => {
                this.isLoading = false;
                this.selectedCanceledOrder = []
                this.dataCanceledOrder = resp.data
                this.showCanceledOrder = true;
            })
            .catch((error)=>{
                this.isLoading = false;
                console.log(error)
            })
        },
        moveIntoUnroutedOrder(){
            // this.isLoading = true ;
            for(const [index, data] of this.selectedCanceledOrder.entries() ){
                let dataSend = {tro_id:data.id};
                this.$http.post('transport/routeplanning_noninternal/order/move-unrouted', dataSend)
                 .then(res => {
                    this.isLoading = false ;
                    this.showCanceledOrder = false ;
                    this.$vs.notify({
                            // title: 'Delete Failed',
                            text: 'Transport Order '+dataSend.tro_id+' moved Unrouted Order',
                            color: 'success'
                    })
                    this.fetchData()
                })
                .catch(error => {
                    this.isLoading = false ;
                    this.showCanceledOrder = false ;
                    console.log(error);
                })
            }
        },      
        moveIntoCancelOrder(){
        this.$vs.dialog({
            type: 'confirm',
            color: 'danger',
            title: 'Move to Canceled Order ',
            text: 'Are you sure want to cancel selected Order ?',
            accept: () => {
                this.isLoading = true ;
                for(const [index, data] of this.selectedOrder.entries() ){
                    let dataSend = {tro_id:data.id};
                    this.$http.post('transport/routeplanning_noninternal/order/move-canceled', dataSend)
                    .then(res => {
                        this.isLoading = false ;
                        this.showCanceledOrder = false ;
                        this.$vs.notify({
                                // title: 'Delete Failed',
                                text: 'Transport Order '+dataSend.tro_id+' was canceled',
                                color: 'success'
                        })
                        this.fetchData()
                    })
                    .catch(error => {
                        this.isLoading = false ;
                        this.showCanceledOrder = false ;
                        console.log(error);
                    })
                }
            },
            acceptText: 'Yes',
            cancelText: 'No'
        });

        },    
        exportTransportNote(){
		   this.isLoading = true
	       this.$http.get('transport/routeplanning_noninternal/report/note/'+this.single_manifest.id, { responseType: 'blob'})
	      .then(response => {
	        var blob = new Blob([response.data], {
	          type: 'application/pdf'
	        });
			 window.open(URL.createObjectURL(blob));
			this.isLoading = false
	        // saveAs(blob, 'putaway_list_'+this.selectedIdReport+'.pdf')
		  })
		  .catch(error => {
			  this.isLoading = false
			  var reader = new FileReader()
				const globalThis = this
				reader.onload = function() {
					globalThis.isLoading = false
					const object = JSON.parse(reader.result)
					const message = object.message ? object.message : 'Something went wrong.'

					globalThis.$vs.notify({
						color: 'danger',
						title: 'Error',
						iconPack: 'feather',
						icon:'icon-x',
						text: message
					})
				}
				reader.readAsText(error.response.data)
		  })
	    },
        setVehicle(){
            this.single_manifest.alter_vehicle_id = this.single_manifest.vehicle_id
            this.setAlterVehicle()
        },
        setAlterVehicle(){
            this.single_manifest.driver = this.single_manifest.alter_vehicle_id.driver
            this.single_manifest.phone = this.single_manifest.alter_vehicle_id.phone
            this.single_manifest.transporter_id = this.single_manifest.alter_vehicle_id.transporter
            this.single_manifest.vehicle_type_id = this.single_manifest.alter_vehicle_id.vehicle_type
        },
        confirmManifest(){

            this.showPopupManifest = false ;
            this.$vs.dialog({
            type: 'confirm',
            color: 'primary',
            title: 'Finish Routing ?',
            text: 'Are you sure want to confirm this manifest ?',
            accept: () => {
                let data = {
                    'manifest_id':this.single_manifest.id
                }
                this.isLoading = true ;
                this.$http.post('transport/routeplanning_noninternal/confirm-manifest', data)
                .then((res) =>{
                    this.isLoading = false ;
                    this.showPopupManifest = false ;
                    this.fetchData();
                    this.$vs.notify({
                        title: 'Confirm Success',
                        text: 'Manifest '+data.manifest_id+' successfully confirmed',
                        color: 'success'
                    })
                })
                .catch((error) => {
                    this.isLoading = false ;
                    for (const [index, err] of error.response.data.entries()) {
                      this.$vs.notify({
                      color: "danger",
                      iconPack: "feather",
                      icon: "icon-x",
                      text: "" + err
                      });
                    }
                })
                

            },
            cancel: ()=>{
                this.showPopupManifest = true ;
            },
            acceptText: 'Yes',
            cancelText: 'No'
        });
        },
        handleFileUpload(event){
          this.file = event.target.files[0];
        },
        updateManifest(){
            let document_send = {
                module_id:this.single_manifest.id,
                module_name:'route'
            };
            let file = new FormData();
            file.append("file_name",this.file);
            this.$http.post('/attachment/uploads',file,{
              headers: {
                  "Content-Type": "multipart/form-data"
              },
              params: document_send
            })
            .then((resp) => {
                // this.$router.replace('/inbound-delivery');
                // this.on_edit = false;
                this.isLoading = false

                this.$vs.notify({
                color: 'success',
                title: 'Update Success',
                text: 'Update Attachment Succesfully'
                });
               
            })
            .catch((error) =>{
                this.isLoading = false               
            });
            let data = Object.assign({},this.single_manifest) 
            data.client_id = this.single_manifest.client_id == null ? null : this.single_manifest.client_id.id
            data.warehouse_id = this.single_manifest.warehouse_id == null ? null : this.single_manifest.warehouse_id.id
            data.vehicle_id = this.single_manifest.vehicle_id == null ? null : this.single_manifest.vehicle_id.id
            data.alter_vehicle_id = this.single_manifest.alter_vehicle_id == null ? null : this.single_manifest.alter_vehicle_id.id
            data.origin_id = this.single_manifest.origin_id == null ? null : this.single_manifest.origin_id.id
            data.destination_id = this.single_manifest.destination_id == null ? null : this.single_manifest.destination_id.id
            data.transporter_mode_id = this.single_manifest.transporter_mode_id == null ? null : this.single_manifest.transporter_mode_id.id
            data.driver = this.single_manifest.driver
            data.phone = this.single_manifest.phone
            data.vehicle_type_id = this.single_manifest.vehicle_type_id == null ? null : this.single_manifest.vehicle_type_id.id
            data.transporter_id = this.single_manifest.transporter_id == null ? null : this.single_manifest.transporter_id.id
            this.isLoading = true ;
            this.$http.put('transport/manifest/'+this.single_manifest.id+'/update', data)
            .then((res)=>{
                console.log(data)
                this.isLoading = true;
                this.editMode = false;
                this.showPopupManifest = false;
                this.$vs.notify({
                    color: 'success',
                title: 'Update Success',
                iconPack: 'feather',
                icon:'icon-check',
                text: 'Manifest Succesfully Updated'
            })
            })
            .catch((error)=>{
                console.log(data)
                this.isLoading = false ;
                for (const [index, err] of error.response.data.entries()) {
                    this.$vs.notify({
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-x",
                    text: "" + err
                    });
                }
            })
        },
        discardManifest(){
            this.editMode = false;
            this.single_manifest = Object.assign({}, this.oldManifest) ;
        },
        editManifest(){
            this.isLoading = true;
            if(!this.masterSync){
                this.$http.all([
                this.$http.post('master/clients'), 
                this.$http.post("master/areas"),
                this.$http.post("master/transporters"),
                this.$http.post("master/vehicle?page=1"),
                this.$http.post("master/warehouses"),       
                this.$http.post("master/vehicletypes"),
                this.$http.post("master/contracttypes"),
                this.$http.post("master/transportersmode"),
                ])
                .then(
                this.$http.spread(
                    (
                    clients,
                    areas,
                    transporters,
                    vehicles,
                    warehouses,
                    vehicletypes,
                    contracttypes,
                    mode,
                    ) => {
                        this.areaOptions = [];
                        this.areaOptions = areas.data.data;
                        this.clientOption = clients.data.data;
                        this.transporterOption = transporters.data.data;
                        this.vehicleOption = vehicles.data.data;
                        this.warehouseOptions = warehouses.data.data;
                        this.vehicleTypeOption = vehicletypes.data.data;
                        this.contractTypeOption = contracttypes.data.data;
                        this.transporterModeOption = mode.data.data;
                        setTimeout(() => {
                            this.isLoading = false;
                            this.editMode = true;
                             this.masterSync = true ;
                        }, 500);
                    }
                )
                )
                .catch((error) => {
                    this.isLoading = false;
                    this.masterSync = false ;
                    console.log(error)
                });
            }else{
                this.editMode = true;
                this.isLoading = false;
            }
        },
        viewManifest(id){
            this.isLoading = true ;
            this.editMode = false ;
            this.activeTab = 0 ;
            this.scanMode = false ;
            this.single_manifest = {
                id:'',
                trip:'',
                schedule_date:'',
                reference:'',
                origin_id:null,
                destination_id:null,
                status:{
                    id:'',
                    name:''},
                client_id:null,
                warehouse_id:null,
                driver:'',
                phone:'',
                vehicle_id:{
                    box_dimension: '',
                    cap_volume: '',
                    cap_weight: '',
                    contract_type_id: null,
                    driver: '',
                    phone: '',
                    transporter_id: null,
                    vehicle_code: '',
                    vehicle_type_id: null,

                },
                load_volume:'',
                load_weight:'',
                load_quantity:'',
                alter_vehicle_id:null,
                transporter_id: null,
                vehicle_type_id:null,
                transporter_mode_id:null,
                container_number:'',
                seal_number:'',
                vessel_number:'',
                voyage_number:'',

            };
            this.$http.get('transport/routeplanning_noninternal/'+id+'/show')
            .then(res => {
                this.isLoading = false ;
                this.showPopupManifest = true ;
                this.single_manifest = res.data;
                this.single_manifest.vehicle_id = res.data.vehicle;
                this.single_manifest.alter_vehicle_id = res.data.alter_vehicle;
                this.single_manifest.client_id = res.data.client;
                this.single_manifest.warehouse_id = res.data.warehouse;
                this.single_manifest.origin_id = res.data.origin;
                this.single_manifest.destination_id = res.data.destination;
                this.single_manifest.transporter_mode_id = res.data.transporter_mode;
                
                this.single_manifest.order_list =  res.data.order_list || []

                this.single_manifest.driver = res.data.driver == null ? res.data.vehicle.driver : res.data.driver;
                this.single_manifest.phone = res.data.phone == null ? res.data.vehicle.phone : res.data.phone;

                this.single_manifest.vehicle_type_id = res.data.vehicle_type == null ? res.data.vehicle.vehicle_type : res.data.vehicle_type;
                this.single_manifest.transporter_id = res.data.transporter == null ? res.data.vehicle.transporter : res.data.transporter ;
                this.oldManifest = Object.assign({}, this.single_manifest) ;
                // Object.freeze(this.oldManifest);
            })
            .catch(error => {
                this.isLoading = false ;
                console.log(error);
            })
        },
        addOrderIntoManifest(){
            this.isLoading = true ;
            for(const [index, data] of this.selectedOrder.entries() ){
                let dataSend = {manifest_id:this.selectedManifest.id, tro_id:data.id};
                this.$http.post('transport/routeplanning_noninternal', dataSend)
                 .then(res => {
                    this.isLoading = false ;
                    this.showAddManifest = false ;
                    this.$vs.notify({
                            // title: 'Delete Failed',
                            text: 'TRO '+dataSend.tro_id+' was added into manifest '+dataSend.manifest_id,
                            color: 'success'
                    })
                    this.fetchData()
                })
                .catch(error => {
                    this.isLoading = false ;
                    this.showAddManifest = false ;
                    console.log(error);
                })
            }
        },
        removeManifest(data){
            if(data.order_list.length > 0){
                this.$vs.notify({
                    color: 'warning',
                    // title: 'Delete failed',
                    text: 'Please, remove all order if you want to delete this manifest'
                })
                return;
            }
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: 'Delete Manifest ',
                text: 'Are you sure want to delete this manifest ?',
                accept: () => {
                    this.isLoading = true ;
                    this.$http.delete('transport/manifestnoninternal/' + data.id + '/destroy')
                    .then(res => {
                        this.$vs.notify({
                            color: 'success',
                            title: 'Delete Successfully',
                            iconPack: 'feather',
                            icon:'icon-check',
                            text: 'The selected Manifest was successfully deleted'
                        })
                        this.fetchData();
                    })
                    .catch(error => {
                        this.isLoading = false ;
                        const message = error.response.data.message ? error.response.data.message : 'Something went wrong'
                        this.$vs.notify({
                            title: 'Delete Failed',
                            text: message,
                            color: 'danger'
                        })
                    })
                },
                acceptText: 'Yes',
                cancelText: 'No'
            });
        },
        moveToUnroutedOrder(id){
           this.isLoading = true ;
            this.$http.delete('transport/routeplanning/' + id + '/destroy')
            .then(res => {
                this.$vs.notify({
                    color: 'success',
                    // title: 'Unroute Successfully',
                    // iconPack: 'feather',
                    // icon:'icon-check',
                    text: 'The selected order was moved to Unrouted Order'
                })
                this.fetchData();
            })
            .catch(error => {
                this.isLoading = false ;
                const message = error.response.data.message ? error.response.data.message : 'Failed to move to unroute order'
                this.$vs.notify({
                    title: 'Delete Failed',
                    text: message,
                    color: 'danger'
                })
            })
        },
        moveToUnroutedOrderFromTab(id){
           this.isLoading = true ;
            this.$http.delete('transport/routeplanning/' + id + '/destroy')
            .then(res => {
                this.$vs.notify({
                    color: 'success',
                    // title: 'Unroute Successfully',
                    // iconPack: 'feather',
                    // icon:'icon-check',
                    text: 'The selected order was moved to Unrouted Order'
                })
                this.finishScan();
            })
            .catch(error => {
                this.isLoading = false ;
                const message = error.response.data.message ? error.response.data.message : 'Failed to move to unroute order'
                this.$vs.notify({
                    title: 'Delete Failed',
                    text: message,
                    color: 'danger'
                })
            })
        },
        moveToCanceledOrder(id){
           this.isLoading = true ;
            let dataSend = {tro_id:id};
            this.$http.post('transport/routeplanning/order/move-canceled', dataSend)
            .then(res => {
                this.$vs.notify({
                    color: 'success',
                    // title: 'Unroute Successfully',
                    // iconPack: 'feather',
                    // icon:'icon-check',
                    text: 'The selected order was moved to Canceled Order'
                })
                this.fetchData();
            })
            .catch(error => {
                this.isLoading = false ;
                const message = error.response.data.message ? error.response.data.message : 'Failed to move to canceled order'
                this.$vs.notify({
                    text: message,
                    color: 'danger'
                })
            })
        },
         moveToCanceledOrderFromTab(id){
           this.isLoading = true ;
            let dataSend = {tro_id:id};
            this.$http.post('transport/routeplanning/order/move-canceled', dataSend)
            .then(res => {
                this.$vs.notify({
                    color: 'success',
                    // title: 'Unroute Successfully',
                    // iconPack: 'feather',
                    // icon:'icon-check',
                    text: 'The selected order was moved to Canceled Order'
                })
                this.finishScan();
            })
            .catch(error => {
                this.isLoading = false ;
                const message = error.response.data.message ? error.response.data.message : 'Failed to move to canceled order'
                this.$vs.notify({
                    text: message,
                    color: 'danger'
                })
            })
        },
        addManifest(){
            if(this.selectedVehicle == '' || this.selectedVehicle == null){
                this.$vs.notify({
                    text: "Please, Select Vehicle ID",
                    color: 'danger'
                })
                return;
            }

            if(this.trip_count <= 0){
                this.$vs.notify({
                    text: "Assigned Trip must be higher than 0",
                    color: 'danger'
                })
                return;
            }

            let dataSend = {
                vehicle_id:this.selectedVehicle.id,
                trip:this.trip_count,
            }
            this.$http.post('transport/manifestnoninternal', dataSend)
            .then(resp => {
                this.fetchData();
                setTimeout(() => {
                    this.isLoading = false
                    this.showAddVehicle = false
                    this.$vs.notify({
                    title: 'Success Add',
                    text: 'Add Manifest Successfully',
                    color: 'success'
                })
                }, 500)
            }).catch(resp => {
                this.isLoading = false;
                console.log(resp)
            })

        },
        showManifestPopup(){
            this.isLoading = true;
            this.selectedManifest = '';
            this.$http.get('transport/routeplanning_noninternal/manifest_list')
            .then(resp => {
                this.dataManifest = resp.data
                setTimeout(() => {
                    this.isLoading = false
                    this.showAddManifest = true
                }, 500)
            }).catch(resp => {
                this.isLoading = false;
                console.log(resp)
            })
        },
        showVehiclePopup(){
            this.selectedVehicle = '';
            this.isLoading = true;
            //add parameter nopage
            this.$http.post('master/vehicle?nopage=y')
            .then(resp => {
                this.dataVehicles = resp.data.data
                let count = resp.data.total / resp.data.per_page ;
                this.totalPages = count 
                setTimeout(() => {
                    this.isLoading = false
                    this.showAddVehicle = true
                }, 500)
            }).catch(resp => {
                this.isLoading = false;
                console.log(resp)
            })
        },
        updateSearchQuery(val) {
            this.gridApi.setQuickFilter(val)
        },
        onSelectionChanged() {
            var selectedRows = this.gridApi.getSelectedRows()
            var selectedRowsString = ''
            selectedRows.forEach(function(selectedRow, index) {
                if (index !== 0) {
                selectedRowsString += ', '
                }
                selectedRowsString += selectedRow.id
            })
            this.selectedId = selectedRowsString
        },
        removeItem () {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: 'Confirm',
                text: 'Are you sure want to delete this outbound?',
                accept: this.acceptAlert
            })
        },
        acceptAlert() {
            this.isLoading = true
            this.$http.delete('transport/transportorder/' + this.selectedId + '/destroy')
            .then(res => {
                this.$vs.notify({
                    color: 'success',
                    title: 'Transport Order deleted',
                    iconPack: 'feather',
                    icon:'icon-check',
                    text: 'The selected Transport Order was successfully deleted'
                })
            })
            .catch(error => {
                const message = error.response.data.message ? error.response.data.message : 'Something went wrong'
                this.$vs.notify({
                    title: 'Error',
                    text: message,
                    color: 'danger'
                })
            })
            .then(() => {
                this.fetchData()
            })
        },
        refreshData() {
            this.maxRetry = 10
            this.fetchData()
        },
        fetchData() {
            this.isLoading = true
            this.maxRetry = this.maxRetry - 1
            this.transports = []
            this.manifest = []
            this.selectedVehicle = []
            this.selectedOrder = []
            this.selectedManifest = []
            this.areaOptions = []

            this.$http.all([this.$http.get('transport/routeplanning_noninternal/unrouted'), this.$http.get('transport/routeplanning_noninternal/manifest'), this.$http.post('unlock_all')])
            .then(this.$http.spread((transport, manifest, areas, unlock) => {
                this.manifest = manifest.data
                this.transports = transport.data
                setTimeout(() => {
                    this.isLoading = false
                }, 500)
            }))
            .catch(resp => {
                if(this.maxRetry == 0){
                    this.isLoading = false
                    this.$vs.dialog({
                        type: 'confirm',
                        color: 'danger',
                        title: 'Server Error',
                        text: 'Try again?',
                        accept: () => {
                            this.refreshData()
                        },
                        acceptText: 'Yes',
                        cancelText: 'No'
                    });
                    return;
                }
                this.fetchData()
            })
        },
        viewData() {
            this.$router.push({
                name: 'transportorder-view',
                params: {
                    id: this.selectedId
                }
            })
        },
        filterData() {
            this.isLoading = true
            this.transports = []
            let dataFilter = Object.assign({}, this.filter) 
            dataFilter.origin_area_id = this.filter.origin_area_id != null ? this.filter.origin_area_id.id : null
            dataFilter.destination_area_id = this.filter.destination_area_id != null ? this.filter.destination_area_id.id : null
            this.$http.post('transport/routeplanning_noninternal/unrouted/filter',dataFilter)
            .then(resp => {
                this.transports = resp.data
                setTimeout(() => {
                    this.isLoading = false
                }, 500)
            })
        },
        filterActive() {
            this.filter = {
                transport_reference:'',
                origin:'',
                origin_area_id:null,
                destination:'',
                destination_area_id:null,
            }
            this.isLoading = true;
            this.$http.all([
                this.$http.post("master/areas"),
            ])
                .then(
                this.$http.spread((areas, clienttypes) => {
                    this.areaOptions = areas.data.data;
                    setTimeout(() => {
                    this.isLoading = false;
                    this.showFilter = true;
                    }, 500);
                })
                )
                .catch(() => {
                this.maxRetry = this.maxRetry - 1;
                if (this.maxRetry < 0) {
                    this.isLoading = false;
                    this.$vs.dialog({
                    type: "confirm",
                    color: "danger",
                    title: "Server Error",
                    text: "Try again?",
                    accept: () => {
                        this.maxRetry = 10;
                        this.filterActive();
                    },
                    acceptText: "Yes",
                    cancelText: "No"
                    });
                    return;
                }
                this.filterActive();
                });
            },
         searchArea(search, loading) {
                if(search.length > 2){
                    loading(true)
                    const data = {
                        village: search
                    }
                    this.$http.post('master/areas', data)
                    .then(res => {
                        this.areaOptions = res.data.data
                        loading(false)
                    })
                    .catch((error) => {
                        loading(false)
                        console.log(error)
                        // this.searchArea(search, loading)
                    })
                }
            },
        updateAWB(id) {
            this.update.show = true;
            this.update.id = id;
        },
        getNewAWB() {
            const data = {
                id: this.update.id,
            }

            this.isLoading = true;

            this.$http.post('transport/routeplanning/get-new-awb', data)
            .then(res => {
                this.update.awb = res.data.awb;
                this.saveNewAWB();
            })
            .catch(error => this.handleError(error));
        },
        saveNewAWB() {
            const data = {
                id: this.update.id,
                awb: this.update.awb
            }

            this.isLoading = true;

            this.$http.post('transport/routeplanning/update-awb', data)
            .then(res => {
                this.$vs.notify({
                    color: 'success',
                    title: 'Success',
                    iconPack: 'feather',
                    icon:'icon-check',
                    text: res.data.message || 'Updated successfully'
                });

                this.update.show = false;

                this.isLoading = false;
            })
            .catch(error => this.handleError(error));
        }
    },
    mounted() {
        this.fetchData()
        this.gridApi = this.gridOptions.api;
         this.$http.get('attachment/'+this.$route.params.id).then((res) => {
            this.attachments = res.data.result
        });
    },
    beforeMount() {
        this.columnDefs = [
            {
                headerName: 'ID',
                field: 'id',
                width: 100,
                filter: true,
                hide: true,
                // checkboxSelection: true,
                // headerCheckboxSelectionFilteredOnly: true,
                // headerCheckboxSelection: true,
            },
            {
                headerName: 'Reference',
                field: 'transport_reference',
                width: 100,
                filter: true,
                // checkboxSelection: true,
                // headerCheckboxSelectionFilteredOnly: true,
                // headerCheckboxSelection: true,
            },
            {
                headerName: 'Client ID',
                field: 'client.client_code',
                width: 100,
                filter: true,
                // checkboxSelection: true,
                // headerCheckboxSelectionFilteredOnly: true,
                // headerCheckboxSelection: true,
            },
            {
                headerName: 'Outbound Reference',
                field: 'outbound_id',
                filter: true,
                width: 100,
            },
            {
                headerName: 'Req. Del. Date',
                field: 'req_del_date',
                filter: true,
                width: 100,
                // pinned: 'left'
            },
            {
                headerName: 'Origin',
                field: 'origin.name',
                filter: true,
                width: 150,
            },
            {
                headerName: 'Orig. Address',
                field: 'origin.address_1',
                filter: true,
                width: 150,
            },
            {
                headerName: 'Orig. Area',
                field: 'origin_area.village',
                filter: true,
                width: 150,
            },
            {
                headerName: 'Destination',
                field: 'destination.name',
                filter: true,
                width: 150,
            },
            {
                headerName: 'Dest. Address',
                field: 'destination.address_1',
                filter: true,
                width: 150,
            },
            {
                headerName: 'Dest. Area',
                field: 'destination_area.village',
                filter: true,
                width: 150,
            },
            {
                headerName: 'Quantity',
                field: 'sum_qty',
                filter: true,
                width: 120,
            },
            {
                headerName: 'Volume (M3)',
                field: 'base_nw',
                filter: true,
                width: 120,
            },
            {
                headerName: 'Weight (KG)',
                field: 'base_gw',
                filter: true,
                width: 120,
            },
        ];
    }
}

</script>

<style type="text/css">
    #my-collapse .vs-collapse-item--header {
        font-size: 1rem;
        padding: 1rem;
    }
    #routedOrder .vs-table--tbody-table .tr-values td {
        padding: 4px 6px;
    }
    .con-vs-dropdown--menu {
        z-index: 99999;
    }
    #myPopup.con-vs-popup .vs-popup {
        width: 1200px;
    }
    #myPopup2.con-vs-popup .vs-popup {
        width: 90%;
    }
    #ActionDDL.con-vs-dropdown--menu {
        width: 170px;
    }
    #stat-chip {
      min-height: 12px;
      min-width: 12px;
      max-height: 12px;
      max-width: 12px;
    }
</style>
